var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "#AA9A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 5.1547C15.2376 4.44017 16.7624 4.44017 18 5.1547L24.3923 8.8453C25.6299 9.55983 26.3923 10.8803 26.3923 12.3094V19.6906C26.3923 21.1197 25.6299 22.4402 24.3923 23.1547L18 26.8453C16.7624 27.5598 15.2376 27.5598 14 26.8453L7.6077 23.1547C6.37009 22.4402 5.6077 21.1197 5.6077 19.6906V12.3094C5.6077 10.8803 6.37009 9.55983 7.6077 8.8453L14 5.1547Z",
    fill: "#AA9A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.1547C15.2376 4.44017 16.7624 4.44017 18 5.1547L24.3923 8.8453C25.6299 9.55983 26.3923 10.8803 26.3923 12.3094V19.6906C26.3923 21.1197 25.6299 22.4402 24.3923 23.1547L18 26.8453C16.7624 27.5598 15.2376 27.5598 14 26.8453L7.6077 23.1547C6.37009 22.4402 5.6077 21.1197 5.6077 19.6906V12.3094C5.6077 10.8803 6.37009 9.55983 7.6077 8.8453L14 5.1547Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9056 11.9333C18.1244 11.9333 19.09 12.4302 19.9244 13.0865L21.4994 10.799C20.2525 9.80521 18.6963 9.23334 16.9056 9.23334C12.8931 9.23334 9.81814 12.1958 9.81814 16.0208C9.81814 19.8458 12.8931 22.8083 16.9056 22.8083C18.7713 22.8083 20.4775 22.1521 21.7244 21.0552V15.1771H16.0431V17.5583H18.6119V19.7615C18.1431 20.0427 17.4869 20.2021 16.9056 20.2021C14.6744 20.2021 12.9494 18.3927 12.9494 16.0677C12.9494 13.6958 14.6556 11.9333 16.9056 11.9333Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 5.60767,
    y: 4.6188,
    width: 20.7846,
    height: 25.0124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 7.81812,
    y: 9.23334,
    width: 15.9063,
    height: 17.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/Gold.12da907be55ebdee0e3007253e881c50.svg";
export { ForwardRef as ReactComponent };